import { render, staticRenderFns } from "./header-wrapper.vue?vue&type=template&id=7078de31&"
import script from "./header-wrapper.vue?vue&type=script&lang=js&"
export * from "./header-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports